import React from "react";

export default function ContactUs() {
  return (
    <div className="container my-5">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-10">
          <div className="card shadow-sm">
            <div className="card-body">

              <h3 className="mb-4 text-center">Contact Us</h3>

              {/* ================= PANJAB UNIVERSITY INFO ================= */}
              <div className="mb-4">
                <h5>PANJAB UNIVERSITY</h5>
                <p className="mb-3">
                  We value your feedback and are here to assist you with any questions or concerns you may have. 
                  Please feel free to reach out to us using the information provided below.
                </p>

                <p className="mb-2">
                  <strong>Email ID:</strong>{" "}
                  <a href="mailto:edc@pu.ac.in">edc@pu.ac.in</a>
                </p>

                <p className="mb-3">
                  <strong>Technical Support:</strong>{" "}
                  <a href="mailto:edc@pu.ac.in">edc@pu.ac.in</a>
                </p>

                <p className="mb-2">
                  <strong>Address:</strong><br />
                  Manager Support Team<br />
                  Sector 14,<br />
                  Panjab University,<br />
                  Chandigarh 160 014
                </p>
              </div>

              <hr />

              {/* ================= CONTACT FORM ================= */}
              <h5 className="mb-3">Send Us a Message</h5>

              <form
                action="mailto:edc@pu.ac.in"
                method="post"
                encType="text/plain"
              >
                <div className="row">

                  <div className="col-12 col-md-6 mb-3">
                    <label className="form-label">Your Name</label>
                    <input
                      type="text"
                      name="Name"
                      className="form-control"
                      required
                    />
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <label className="form-label">Email Address</label>
                    <input
                      type="email"
                      name="Email"
                      className="form-control"
                      required
                    />
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <label className="form-label">Contact Number</label>
                    <input
                      type="text"
                      name="Contact"
                      className="form-control"
                    />
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <label className="form-label">Subject</label>
                    <input
                      type="text"
                      name="Subject"
                      className="form-control"
                    />
                  </div>

                  <div className="col-12 mb-3">
                    <label className="form-label">Message</label>
                    <textarea
                      name="Message"
                      className="form-control"
                      rows="4"
                      required
                    ></textarea>
                  </div>

                  <div className="col-12 text-center">
                    <button type="submit" className="btn btn-primary px-5">
                      Send Message
                    </button>
                  </div>

                </div>
              </form>

              <p className="text-muted mt-3 text-center" style={{ fontSize: "0.9rem" }}>
                * Your default email client will open when you submit the form.
              </p>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
